module.exports = __webpack_public_path__ + "static/media/06.aeee2913.jpg";